<template>
  <listwise-list
    v-if="list"
    :list="list"
    :header_link="false"
    :editable="canEdit"
    :details="true"
    :menu="true"
  >
  </listwise-list>
</template>

<script>
import ListwiseList from '@/components/ListwiseList'

export default {
  name: 'List',
  components: {
    ListwiseList
  },
  created () {
    this.$store.dispatch('lists/getList', this.$route.params.id)
  },
  computed: {
    canEdit () {
      if (!this.list.creator) {return false}
      return this.list.creator.username === this.$store.state.users.user.username
    },
    isAuth () {
      return this.$store.getters['users/isAuth']
    },
    list () {
      return this.$store.getters['lists/currentList']
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>

</style>
